import { HTMLAttributes } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import cx from 'classnames';

import { entryToLink } from '../lib/copyRendering';
import { Column, Row, Section } from './Section';
import { ProductLogosFragment } from './ProductLogos.generated';

interface ProductLogosProps {
  snippetGroup: ProductLogosFragment | undefined;
  className?: HTMLAttributes<HTMLDivElement>['className'];
}

export const ProductLogos: React.FC<ProductLogosProps> = ({
  snippetGroup,
  className,
}) => (
  <Section className={cx('bg-gray-50 !py-4 lg:!py-2.5', className)}>
    <Row>
      <Column className="flex justify-center flex-col sm:flex-row sm:flex-wrap !mx-auto max-w-3xl 2xl:max-w-none">
        {snippetGroup?.snippetsCollection?.items.map(
          (logoSnippet) =>
            logoSnippet?.__typename === 'Snippet' &&
            logoSnippet?.image?.url &&
            logoSnippet.image.width &&
            logoSnippet.image.height && (
              <Link
                href={entryToLink(logoSnippet.link)}
                className={cx('!m-4 p-4 bg-white', {
                  'rounded-lg shadow-md hover:bg-blue-50': entryToLink(
                    logoSnippet.link,
                  ),
                })}
                key={logoSnippet.key}
              >
                <Image
                  src={logoSnippet.image.url}
                  width={logoSnippet.image.width / 2}
                  height={logoSnippet.image.height / 2}
                  alt={logoSnippet.image.description ?? 'Product logo'}
                />
              </Link>
            ),
        )}
      </Column>
    </Row>
  </Section>
);
